import { defineMessages } from 'react-intl';

export default defineMessages({
  priceBreakdownRecyclingFeeWhatIsThis: {
    id: 'WhatIsThisFee.whatIsThis',
    description:
      'Message for the price breakdown products recycling fee >what is this<',
    defaultMessage: 'What\'s this?',
  },
  buttonBackLabel: {
    id: 'WhatIsThisFee.buttonBackLabel',
    description: 'Label for the back button in RecyclingFeeTooltip flyout',
    defaultMessage: 'Back to Checkout',
  },
  recyclingFeeModalTitle: {
    id: 'WhatIsThisFee.modalTitle',
    description: 'Fees modal title',
    defaultMessage: 'Fees by State',
  },
  paragraphTitle01: {
    id: 'WhatIsThisFee.CaliforniaTitle',
    description: 'California Paragraph title',
    defaultMessage: 'California',
  },
  paragraphContent01: {
    id: 'WhatIsThisFee.CaliforniaContent',
    description: 'California Paragraph content',
    defaultMessage: `On Jan 1, 2025 CalRecycle approved 
    the $16 recycling fee and MRC’s budget. 
    Plan approval followed on Jan. 29, 2016.`,
  },
  paragraphTitle02: {
    id: 'WhatIsThisFee.ConnecticutTitle',
    description: 'Connecticut Paragraph title',
    defaultMessage: 'Connecticut',
  },
  paragraphContent02: {
    id: 'WhatIsThisFee.ConnecticutContent',
    description: 'Connecticut Paragraph content',
    defaultMessage: `
    Connecticut’s mattress recycling law requires mattress producers 
    to establish and join a nonprofit organization charged with 
    creating a mattress stewardship (recycling) program to 
    manage unwanted mattresses and box springs in the state 
    (CGS § 22a-905 et seq.). The mattress industry created 
    the Mattress Recycling Council (MRC) to fulfill this requirement. 
    The state neither administers the program, nor collects its fees. 
    MRC branded the program as “Bye Bye Mattress.” As required by law, 
    a fee is charged at the point of sale, which the retailer transmits 
    to MRC. The fee is currently set at $16 per unit 
    (mattress or box spring) and pays for such things as collecting, 
    transporting, and processing discarded mattresses; audits; 
    public education materials; and maintaining a financial reserve. 
    Although MRC is principally responsible for the program, the state’s 
    Department of Energy and Environmental Protection (DEEP) is, 
    however, tasked with enforcing the law’s requirements.
    `,
  },
  paragraphTitle03: {
    id: 'WhatIsThisFee.RhodeIslandTitle',
    description: 'Rhode Island title',
    defaultMessage: 'Rhode Island',
  },
  paragraphContent03: {
    id: 'WhatIsThisFee.RhodeIslandContent',
    description: 'Rhode Island Paragraph content',
    defaultMessage: `
    In July 2013, Rhode Island enacted General Law 23-90, which requires
    mattress manufacturers to create a statewide recycling program for
    discarded mattresses. The program began May 1, 2016, and is funded
    through a $20.50 visible recycling fee collected at retail from customers
    on each mattress and foundation sold in the state. These fees fund
    the collection and recycling of mattresses and foundations used and
    discarded in Rhode Island.      
    `,
  },
  paragraphTitle04: {
    id: 'WhatIsThisFee.ColoradoTitle',
    description: 'Colorado title',
    defaultMessage: 'Colorado',
  },
  paragraphContent04: {
    id: 'WhatIsThisFee.ColoradoContent',
    description: 'Colorado Paragraph content',
    defaultMessage: `
    Effective July 1, 2022, in an effort to address sustainability 
    of the transportation system in the state, Colorado imposes 
    a $0.29 retail delivery fee on all deliveries by motor 
    vehicle to a location in Colorado with at least one item 
    of tangible personal property subject to state sales tax. 
    This retail delivery fee is included when any Purple product 
    is mailed, shipped, or otherwise delivered by motor vehicle 
    to a purchaser in Colorado. As a fee collected and remitted 
    to the Colorado Department of Revenue, this fee is not 
    refundable on product returns.      
    `,
  },

  paragraphOregonTitle: {
    id: 'WhatIsThisFee.paragraphOregonTitle',
    description: 'Oregon title',
    defaultMessage: 'Oregon',
  },
  paragraphOregonContent: {
    id: 'WhatIsThisFee.paragraphOregonContent',
    description: 'Oregon Paragraph content',
    defaultMessage: `
    In January 2025, Oregon’s Department of Environmental Quality (DEQ) 
    authorized the Mattress Recycling Council (MRC) to create a statewide 
    mattress recycling program. The program will be funded by a $22.50 
    per unit DEQ-approved stewardship assessment collected on the sale 
    of each mattress and foundation sold for use in Oregon.
    `,
  },
});
